/*
  NDZ (08/10/2026): indirizzi email non leggibili dai programmi che raccolgono indirizzi per lo spam.
  Nei testi l'indirizzo è un link a «/pages/contact#scrivici» con scritto «mail(at)noodz.it»: nel codice della pagina
  l'indirizzo vero non c'è. Al clic questo script compone l'indirizzo e apre il programma di posta; se lo script non
  parte, il link porta alla pagina Contatti.
*/
(function () {
  var utente = 'mail';
  var dominio = ['noodz', 'it'].join('.');
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#scrivici"]');
    if (!a) return;
    e.preventDefault();
    window.location.href = 'mailto:' + utente + '@' + dominio;
  });
})();
